import { DataStringComponent } from "./data-string-component.js";
import { isNumber } from "@bonusmap/shared_ui/library";

export class DataDatetimeComponent extends DataStringComponent {
    static webComponentName: string = "data-datetime";
    protected _templateId: string = "data-datetime-template";
    protected inputType: string = "datetime-local"; 
    constructor() {
        super();
    }
    
    addDataForTemplate(): Record<string, any> {
        const baseData = super.addDataForTemplate();
        
        // Convert ISO string to YYYY-MM-DDTHH:MM format for datetime-local input
        let editValue = this.value;
        if (this.value && typeof this.value === 'string') {
            const date = new Date(this.value);
            if (isNumber(date.getTime())) {
                // Format as YYYY-MM-DDTHH:MM for HTML datetime-local input
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                editValue = `${year}-${month}-${day}T${hours}:${minutes}`;
            }
        }
        
        // Format for display in Italian
        let displayValue = this.value;
        if (this.value && typeof this.value === 'string') {
            const date = new Date(this.value);
            if (isNumber(date.getTime())) {
                displayValue = date.toLocaleString('it-IT', {
                    day: '2-digit',
                    month: '2-digit', 
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                });
            }
        }
        
        return {
            ...baseData,
            editValue,
            displayValue
        };
    }
}